import cn from 'classnames';
import ReactModal from 'react-modal';
import React, { useEffect, useState, useContext } from 'react';
import { useRouter } from 'next/router';
import { DeleteAddressModal } from '@desquared/wave-components-library';
import User from '@/store/user';
import DeliveryMode from '@/store/deliveryMode';
import { LoginProviderStore } from '@/store/loginProvider';
import CUSTOM_STYLES from '@/utils/modalStyle';
import { PostalCode, SelectedShopId } from '@/store/isAddressRegistered';
import { SideSheetStore, ResponsiveMenuStore, AddressViewSideSheetStore } from '@/store/sideSheet';
import UserListsStore from '@/store/userLists';
import { useTranslations } from 'next-intl';
import { DeliveryStore as DeliveryAddressIndexStore } from '@/store/sideSheet';
import { clearCart } from '@/utils/cart';
import { logoutV3 } from '@/api/register';
import styles from '@/styles/User.module.css';
import { Shop } from '@/store/shop';
import jsonStorage from '@/utils/json-storage.js';
import { shutdown } from '@intercom/messenger-js-sdk';
import { useConfiguration } from '@/contexts/ConfigContext.jsx';
import { DeliveryServicesContext } from '@/contexts/DeliveryServicesContext';

export default function LogoutModal({ showModal, setShowModal }) {
  const [user, setUser] = useState();
  const router = useRouter();
  const t = useTranslations('common.logout_modal');
  const { config } = useConfiguration();
  const { setSelectedShop, selectedService } = useContext(DeliveryServicesContext);

  const emptySelectedShop = () => {
    if (selectedService?.deliversToAddress) {
      SelectedShopId.update('');
      setSelectedShop('');
    }
  };

  async function onClickLogout() {
    const storage = window.localStorage;
    try {
      if (config?.services?.chatbot?.enabled) {
        shutdown();
      }
      jsonStorage.remove('temporaryInvoice', { storage });
      jsonStorage.remove('notSavedInvoiceFlag', { storage });
      await Promise.all([
        User.reset(),
        () => {},
        DeliveryMode.update('easy'),
        LoginProviderStore.clear(),
        UserListsStore.clear(),
        PostalCode.delete(),
        emptySelectedShop(),
        DeliveryAddressIndexStore.update(undefined),
        clearCart(),
        logoutV3(),
      ]);
      // await Promise.all([User.reset(), clearCart(), DeliveryMode.update('easy')]);
    } finally {
      AddressViewSideSheetStore.reset();
      setShowModal(false);
      SideSheetStore.close();
      if (process.env.hasStoreNecessary) {
        router.replace('/welcome');
      } else {
        router.replace('/');
      }
      if (selectedService?.deliversToAddress) {
        Shop.reset();
      }
      ResponsiveMenuStore.close();
    }
  }

  useEffect(() => {
    const user$ = User.subscribe(_user => {
      setUser(_user);
    });

    return () => user$.unsubscribe();
  }, []);

  if (!user?._id) return null;
  return showModal ? (
    <ReactModal
      isOpen={showModal}
      onRequestClose={() => {
        setShowModal(false);
      }}
      style={CUSTOM_STYLES}
      contentLabel={'logout modal'}
      ariaHideApp={false}
      className={cn(styles.modalContainer, styles.modal)}
      shouldCloseOnOverlayClick={true}
    >
      <DeleteAddressModal
        // icon={LoginLogout}
        title={t('title')}
        description={t('description')}
        cancelWording={t('cancel')}
        deleteWording={t('logout')}
        onDelete={() => {
          {
            setShowModal(false);
            /*placeholder for logout */
            onClickLogout();
          }
        }}
        onCancel={() => {
          setShowModal(false);
        }}
      ></DeleteAddressModal>
    </ReactModal>
  ) : (
    <></>
  );
}
